import { tokens } from '../tokens';

export const buttonPrimary = {
  backgroundColor: tokens.colors.primary,
  color: tokens.colors.bgWhite,
  fontSize: tokens.fontSize.small,
  fontWeight: tokens.fontWeight.semibold,
  border: 'none',
  borderRadius: tokens.radius.md,
  cursor: 'pointer',
  transition: `background-color ${tokens.transition.fast}`,
  '&:hover': {
    backgroundColor: tokens.colors.primaryDark,
  },
  '&:focus': {
    outline: `2px solid ${tokens.colors.primaryLight}`,
    outlineOffset: 2,
  },
};

export const buttonSecondary = {
  backgroundColor: 'transparent',
  color: tokens.colors.primary,
  fontSize: tokens.fontSize.small,
  fontWeight: tokens.fontWeight.semibold,
  border: `1px solid ${tokens.colors.primary}`,
  borderRadius: tokens.radius.md,
  cursor: 'pointer',
  transition: `all ${tokens.transition.fast}`,
  '&:hover': {
    backgroundColor: tokens.colors.primaryLight,
  },
  '&:focus': {
    outline: `2px solid ${tokens.colors.primaryLight}`,
    outlineOffset: 2,
  },
};

export const linkStyle = {
  color: tokens.colors.primary,
  textDecoration: 'none',
  cursor: 'pointer',
  transition: `color ${tokens.transition.fast}`,
  '&:hover': {
    color: tokens.colors.primaryDark,
    textDecoration: 'underline',
  },
};

export const focusRing = {
  '&:focus': {
    outline: `2px solid ${tokens.colors.primary}`,
    outlineOffset: 2,
  },
  '&:focus:not(:focus-visible)': {
    outline: 'none',
  },
};

/**
 * Hides the default Ant Design ::before required asterisk.
 * Use this when the component renders its own required indicator
 * manually in JSX (e.g., <span className={classes.required}>*</span>).
 *
 * Usage: `form: { ...antFormRequiredHide }`
 */
export const antFormRequiredHide = {
  '& .ant-form-item-required::before': {
    display: 'none !important',
  },
};

/**
 * Hides the default Ant Design ::before asterisk and shows a consistent
 * red asterisk via ::after. Use this when the component does NOT render
 * its own required indicator — the CSS handles it entirely.
 *
 * Usage: `formContainer: { ...antFormRequired }`
 */
export const antFormRequired = {
  ...antFormRequiredHide,
  '& .ant-form-item-required::after': {
    display: 'inline-block',
    marginLeft: tokens.spacing.xs,
    color: tokens.colors.error,
    fontSize: tokens.fontSize.body,
    lineHeight: 1,
    content: "'*' !important",
  },
};
